export default "__VITE_ASSET__CG9435ti__"